var self = (module.exports = {

	prefix: 'cafsuser_',

	userdatafields: ["id", "username", "authToken", "emailAddress", "displayName", "avatarFileName"],

	privs: null,

	setUserData(userdata) {
		/*We iterate over each element in the userdatafields  array*/
		self.userdatafields.forEach((key) => {
			/*For each element in userdatafields, the updateValue method is called with two arguments:
			 a key and its corresponding value in the userdata object. This will update the self's 
			  properties with the values from the userdata object.*/
			self.updateValue(key, userdata[key]);
		});

		/* This updates the privileges in self with the values found in userdata and 
		assigns the "userdata.privs" value to both the "privs" property and the 
		stringified "privs" value.*/
		self.updateValue("privs", JSON.stringify(userdata.privs));
		self.privs = userdata.privs;

		//We indicate that the code executed succesfully
		return true;
	},

	clearUserData() {
		/*self.userdatafields.forEach((key) => {
			self.updateValue(key, "");
		});
		self.updateValue("username", "");
		self.updateValue("privs", "");*/

		/* We clear all key-value pairs stored in the current domain's local storage.*/
		localStorage.clear();

		/*We set privileges to null*/
		self.privs = null;

		//We indicate that the code executed succesfully
		return true;
	},

	getValue(key) {
		/*This function to retrieves a value from localStorage using the key ${self.prefix}${key}. 
		If that value doesn't exist, it falls back to retrieving the value associated with the key parameter directly.
		 The returned value is then passed back to the calling code.*/
		if(localStorage.getItem(`${self.prefix}${key}`)) {
			return localStorage.getItem(`${self.prefix}${key}`);
		}
		return localStorage.getItem(key);
	},

	updateValue(key, value) {
		/*First, we check if there is already an item in the browser's local storage with the given key.*/
		if(localStorage.getItem(key)) {
			localStorage.setItem(key, value);
		}
		/* If not, we add a new item to the local storage by calling setItem with a new key that is 
		created by concatenating the key argument with a string stored in the self.prefix variable.*/
		localStorage.setItem(`${self.prefix}${key}`, value);
		//localStorage.setItem(key, value);

		//We indicate that the code executed succesfully
		return true;
	},

	hasPriv(key) {
		/*function checks if the self.privs object has a property either called ALL or a property 
		with a name specified by the key parameter, and returns true if either of those conditions is met.*/

		/*If self.privs does not exists, then we parse a JSON string from
		 the result of self.getValue and assign the resulting object to the privs property. */
		if (!self.privs) {
			self.privs = JSON.parse(self.getValue("privs"));
		}
		/*Next, we check if self.privs has a property named 'ALL' that is neither false or null */
		if(typeof self.privs['ALL'] !== "undefined" && self.privs.ALL){
			return true;
		}
		/* Finally, we check that the key property of self.privs is neither false or null */
		if (typeof self.privs[key] !== "undefined" && self.privs[key]) {
			return true;
		}
		return false;
	}
});
